export default class SwedishPhoneNumber {
    static validate(number) {
        if (number) {
            const swedishRegex = /^(\+?46|0)7[02369]-?\d{7}$/;
            const europeanRegex = /^\+(?!46)[1-9]\d{6,14}$/; // E.164 format for non-Swedish European numbers (min 7 digits including country code)
            number = number.replace(/[\s-]/g, ''); // Remove spaces and hyphens

            if (number.match(swedishRegex) || number.match(europeanRegex)) {
                return true;
            }
        }

        return false;
    }
}
